import { createFileRoute } from "@tanstack/react-router";

import ConnectionBuilderPage from "./-components/ConnectionBuilderPage";

export const Route = createFileRoute(
  "/_app/_dashboard/$planId/proxy/connection-builder"
)({
  component: ConnectionBuilderPage,
});
